import { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useStoreState } from "ezStore";
import { intl } from "LocaleWrapper";

import { Card, PageHeader } from "@cofano/cck";

import Helmet from "components/helmet/Helmet";
import { request } from "components/utils/Request2";

import { hasPluginPermission } from "imports/Utils";

type MetabaseRequest = {
	url?: string
};

const Metabase = () => {

	const session = useStoreState((store) => store.session);

	const [ url, setUrl ] = useState<string | undefined>(undefined);

	useEffect(() => {
		if (hasPluginPermission(session, "metabaseDashboard")) {
			request<MetabaseRequest>({
				url: "metabase/dashboard",
			}).then((response) => {
				setUrl(response.url);
			});
		}
	}, []);

	return (
		<div>
			<PageHeader>
				<PageHeader.Title>
					<FormattedMessage id="METABASE" />
					<Helmet title={intl.formatMessage({ id: "METABASE" })} />
				</PageHeader.Title>
			</PageHeader>

			<Card>
				{url && (
					<iframe
						id="iframeDashboard"
						src={url}
						style={{ border: "none", height: "calc(100vh - 174px)", width: "100%" }}
						allowTransparency></iframe>
				)}
			</Card>
		</div>
	);
};

export default Metabase;
